import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../app/store";
import { dismissToast } from "../../stores/notifications/notificationsSlice";

export function ToastHost() {
  const dispatch = useDispatch();
  const toast = useSelector((state: RootState) => state.notifications.queue[0]);

  const handleClose = () => {
    dispatch(dismissToast());
  };

  return (
    <Snackbar
      key={toast?.id}
      open={!!toast}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={toast?.severity ?? "info"}
        variant="filled"
        sx={{ width: "100%" }}
        data-cy={"toast-" + (toast?.severity ?? "info")}
      >
        {toast?.message ?? ""}
      </Alert>
    </Snackbar>
  );
}
